// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__s4joD","label":"LabeledBox_label__iSkvA"};